import { AlertTriangle, CheckCircle2, HelpCircle } from 'lucide-react';

const ESITO_STILE = {
  OK: { className: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: CheckCircle2 },
  ANOMALIA: { className: 'bg-amber-50 text-amber-700 border-amber-200', icon: AlertTriangle },
  NON_VERIFICABILE: { className: 'bg-slate-50 text-slate-500 border-slate-200', icon: HelpCircle },
};

export default function RisultatoRegola({ risultato }) {
  const stile = ESITO_STILE[risultato.esito] || ESITO_STILE.NON_VERIFICABILE;
  const Icona = stile.icon;
  return (
    <div className={`flex items-start gap-3 p-4 rounded-sm border ${stile.className}`}>
      <Icona className="w-5 h-5 mt-0.5 flex-shrink-0" />
      <div className="min-w-0">
        <p className="text-sm font-medium">{risultato.messaggio}</p>
        {(risultato.importo_atteso != null || risultato.importo_rilevato != null) && (
          <p className="text-xs mt-1 opacity-80 font-mono">
            {risultato.importo_atteso != null && <>atteso: €{risultato.importo_atteso.toFixed(2)} </>}
            {risultato.importo_rilevato != null && <>· rilevato: €{risultato.importo_rilevato.toFixed(2)}</>}
          </p>
        )}
        {risultato.riferimento_normativo && (
          <p className="text-xs mt-1 opacity-70">{risultato.riferimento_normativo}</p>
        )}
      </div>
    </div>
  );
}
